import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  accordiondetails: {
    "& .MuiChip-colorPrimary": {
      backgroundColor: theme?.palette?.primary2TextColor?.main,
      color: theme?.palette?.secondaryText?.[700],
      height: "auto"
    }
  },
  chipcontainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px"
  }
}));
